import { debugConsole } from "./debugConsole";

const DEVICE_ID_KEY = "mqttDeviceId";

// In-memory fallback so the id stays stable within a session even when
// localStorage is unavailable (private mode, blocked storage, etc.).
let fallbackDeviceId: string | null = null;

/**
 * Returns a UUID that uniquely and durably identifies this browser/device.
 * Persisted in localStorage so it survives page refreshes and full tab
 * close/reopen — this is what lets the MQTT broker resume the same session
 * (clean: false) after a disconnect instead of dropping queued messages.
 */
export const getOrCreateDeviceId = (): string => {
  try {
    const stored = localStorage.getItem(DEVICE_ID_KEY);
    if (stored) return stored;

    const newId = crypto.randomUUID();
    localStorage.setItem(DEVICE_ID_KEY, newId);
    return newId;
  } catch (error) {
    debugConsole("Error accessing localStorage for deviceId:", error);
    if (!fallbackDeviceId) {
      fallbackDeviceId = crypto.randomUUID();
    }
    return fallbackDeviceId;
  }
};
